export enum CREDIT_LIQUIDATION_ACTIONS {
	BACK_TO_HOME,
	BACK_STEP,
	NEXT_STEP,
	SAVE_FORM_IN_STORAGE,
	SAVE_FORM_IN_SERVICES,
	UPDATE_FORM,
	RESET_ID_STATUS_AND_BACK_STEP
}
